import Step from 'src/components/Step';
import StepperContext from 'src/store/stepper-context';
import { useContext } from 'react';
import AssetPage from 'src/pages/asset';
import AssetModal from 'src/components/modal/AssetModal';
import UploadModal from 'src/components/modal/UploadModal/UploadModal';
import HelpModal from 'src/components/modal/HelpModal';
import assetStepSchema from 'src/components/schemas/assetStepSchema';
import ToastContext from 'src/store/toast-context';
import handleNull from 'src/util/handleNull';
import { useLoaded } from 'src/store/load-context';
import { useAPI } from 'src/services/api';
import { useEffect } from 'react';
import AssetTableContext from 'src/store/asset-table-context';
import AuthContext from 'src/store/auth-context';
import debounce from 'src/util/debounce';

const AssetStep = (props) => {
  const api = useAPI();
  const { setLoaded } = useLoaded();
  const { assetInfo } = useContext(AssetTableContext);
  const { setPropCode, setPropDescriptions, setAssets, assets } = assetInfo;
  const { nextStep } = useContext(StepperContext);
  const { account } = useContext(AuthContext);
  const { error, handleError } = useContext(ToastContext);

  const onError = debounce(
    (errors) => {
      if (errors.assets) {
        error('Please add assets to proceed. It is mandatory for first-time filers.');
      }
    },
    1000,
    { leading: true }
  );

  const initialValues = {
    firstTimeFiler: account.isFirstTimeFiler,
    assets: assets,
  };

  const fetchInitialValues = async () => {
    try {
      setLoaded(false);

      const { data } = handleNull(await api.get('/assets'));

      const { propCode, propDescriptions, assets } = data;

      propDescriptions.unshift({ ppTypeDescr: 'Item Not Listed' });

      //This is setting the context state and will be imported in the AssetModal along with the asset page to populate the table  and input dropdowns
      setPropCode(propCode); //list of property code options that will be used by asset modal prop code dropdown
      setPropDescriptions(propDescriptions); // list of property description options that will be used by asset modal dropdown
      setAssets(assets); // list of users assets that will be used by the asset table

      setLoaded(true);
    } catch (err) {
      handleError(err);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchInitialValues(), []);

  return (
    <Step
      onError={onError}
      initialValues={initialValues}
      component={<AssetPage />}
      onComplete={() => nextStep()}
      schema={assetStepSchema}
      path={['/assets']}
      modals={[
        <AssetModal key="assetModal" />,
        <UploadModal key="uploadModal" />,
        <HelpModal key="helpModal" />,
      ]}
      {...props}
    />
  );
};

export default AssetStep;
